import { render, staticRenderFns } from "./CustomersReseller.vue?vue&type=template&id=11518122&"
import script from "./CustomersReseller.vue?vue&type=script&lang=js&"
export * from "./CustomersReseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports